// Unpublished Work © 2020-2025 Deere & Company.

import {AddCustomerDetail} from '../../state/struct/add-customer/add-customer-detail';
import * as ActionList from '../../action-list';
import {contactPhoneFieldKeys} from '../../state/struct/add-customer/field-keys';

const setError = (state, action) => {
    action.hasError ?
        state.add(action.fieldKey) :
        state.delete(action.fieldKey);

    return state;
};

const setErrorForContactPhone = (state, action) => {
    action.hasError ?
        state.add(`${action.contactPhoneFieldKey}-${action.fieldKey}`) :
        state.delete(`${action.contactPhoneFieldKey}-${action.fieldKey}`);

    return state;
};

const removePhoneErrors = (state, action) => {
    state.delete(`${contactPhoneFieldKeys.AREA_CODE}-${action.fieldKey}`);
    state.delete(`${contactPhoneFieldKeys.PHONE}-${action.fieldKey}`);
    state.delete(`${contactPhoneFieldKeys.EXTENSION}-${action.fieldKey}`);

    return state;
};

const resetError = (state) => {
    state.clear();

    return state;
};

export const validationError = (state = AddCustomerDetail({}).validationError, action = {}) => {
    const actionHandlers = {
        [ActionList.RESET_ADD_CUSTOMER_CONTACT_PHONE]: removePhoneErrors,
        [ActionList.RESET_ADD_CUSTOMER_FORM]: resetError,
        [ActionList.RESET_ADD_CUSTOMER_FORM_VALIDATION]: resetError,
        [ActionList.SET_ADD_CUSTOMER_CONTACT_PHONE]: setErrorForContactPhone,
        [ActionList.SET_ADD_CUSTOMER_EMAIL_INFO]: setError,
        [ActionList.SET_CUSTOMER_NAME_DETAILS]: setError,
        [ActionList.SET_SSN_DETAILS]: setError,
        [ActionList.SET_REGISTRANT_NUMBER_DETAILS]: setError,
        [ActionList.SET_CUSTOMER_PREFIX_AND_GENERATION_DETAILS]: setError,
        [ActionList.SET_EDIT_CUSTOMER]: resetError,
        [ActionList.SET_MAILING_ADDRESS]: setError,
        [ActionList.SET_PHYSICAL_ADDRESS]: setError,
        [ActionList.SET_DBS_CUSTOMER_NAME_DETAILS]: setError,
        [ActionList.SET_DBS_CUSTOMER_PHYSICAL_ADDRESS]: setError,
        [ActionList.SET_DBS_CUSTOMER_MAILING_ADDRESS]: setError,
        [ActionList.SET_DBS_CUSTOMER_CONTACT_PHONE]: setErrorForContactPhone,
        [ActionList.SET_DBS_CUSTOMER_CONTACT_PHONE_ALL]: setErrorForContactPhone,
        [ActionList.SET_DBS_CUSTOMER_EMAIL_INFO]: setError,
        [ActionList.SET_CUSTOMER_PREFIX_AND_GENERATION_DETAILS_FOR_DBS]: setError,
        [ActionList.SET_BUSINESS_TAX_DETAILS]: setError
    };
    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
};
